var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAllYear = function SvgAllYear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "M10.5 5.01a4 4 0 1 0 0 8m-10-4h4m1 8.66 2-3.464m0-10.392L5.5.35",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004586",
    d: "M12.047 10.924a2 2 0 0 0-.025-3.855M13.7 9.062h5m1.557-2.113-2.121 2.122m0 0 2.121 2.121M12.7 7.33 15.2 3M14.149.595l.776 2.898m0 0 2.898-.777M15.2 15.12l-2.5-4.33m1.595 6.988.777-2.897m0 0 2.898.776",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export { SvgAllYear as ReactComponent };
export default __webpack_public_path__ + "e191358f112c5486984ecdd6327a0e3c.svg";